import React, { useState } from "react";
import './Table.css'
import { DataGrid } from "@material-ui/data-grid";
import { DeleteOutline } from "@material-ui/icons"
import { Link } from "react-router-dom";
import { userRows } from "../../dummyData";

function Table() {
    const [data,setData]= useState(userRows);
    const handleDelete = (id) => {
        setData(data.filter((item) => item.id !== id))
    }
    const columns = [
        { field: "id", HeaderName: "ID", width: 100 },
        {
            field: "user", HeaderName: "User", width: 210, renderCell: (params) => {
                return (
                    <div className="userListUser">
                        <img className="userListImg" src={params.row.avatar} alt="" />
                        {params.row.user}
                    </div>
                )
            }
        },
        { field: "email", HeaderName: "Email", width: 230, },
        { field: "status", HeaderName: "Status", width: 130 },
        { field: "transaction", HeaderName: "Transaction Volume", width: 170 },
        {
            field: "action", HeaderName: "Action", width: 160, renderCell: (params) => {
                return (
                    <>
                        <button className="userListEdit">Edit</button>
                        <DeleteOutline className="userListDelete" onClick={()=>handleDelete(params.row.id)} />
                    </>

                )
            }
        }
    ];
    return (
        <main>
            <div className="main_container">
                <DataGrid rows={data} disableSelectionOnClick columns={columns} pageSize={9} checkboxSelection />
            </div>
        </main>
    )
}

export default Table;